import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";

export default function SingleProductItem({ item, params }) {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org/",
 "@type": "Product",
 "name": "${item.name}",
 "image": "${item.image}",
 "description": "${item.description}",
 "sku": "GOLD123",
 "brand": {
 "@type": "Brand",
 "name": "طلایی شو"
 },
 "offers": {
 "@type": "Offer",
 "priceCurrency": "IRR",
 "price": "${item.product_price}",
 "itemCondition": "https://schema.org/NewCondition",
 "availability": "https://schema.org/InStock",
 "url": "https://talaeshow.com/products/gold-bar-1g"
 }
}
          `}
        </script>
      </Helmet>
      <div
        className="home-carousel-card"
        key={`carousel-home-product-${item.id}`}
      >
        <Link
          className={params.isFull ? "" : "hdash-carousel-link"}
          to={params.landing ? "/sign" : "/trade-market"}
        >
          <div className="d-block popular-article-image home-carousel-image">
            <img src={item.image} alt={item.name} />
          </div>
          <div className="left-box-carousel">
            <div>
              <div className="home-carousel-text">{item.name}</div>
              <div className="home-carousel-text">{item.description}</div>
              <div className="home-carousel-text home-carousel-price-text">
                قیمت :{" "}
                {new Intl.NumberFormat("fa", {
                  maximumFractionDigits: 0,
                }).format(item?.product_price)}{" "}
                تومان
              </div>
            </div>
            <div className="button-row-home-crsl">
              <button
                className="buy-btn-home-carousel"
                onClick={() =>
                  navigate(params.landing ? "/sign" : "/trade-market")
                }
              >
                خرید
              </button>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}
